
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface PastSessionsProps {
  sessions: any[];
}

export const PastSessions = ({ sessions }: PastSessionsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {sessions.map((session) => (
        <Card key={session.id}>
          <CardHeader>
            <CardTitle>
              {session.session.title || `Session with ${session.session.host.username}`}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-500">
              {new Date(session.session.start_time).toLocaleDateString()} at{' '}
              {new Date(session.session.start_time).toLocaleTimeString()}
            </p>
          </CardContent>
        </Card>
      ))}
      {sessions.length === 0 && (
        <p className="text-gray-500">No past sessions.</p>
      )}
    </div>
  );
};
